<div class="component-container mat-typography mat-body mat-app-background">
  <div class="application-details">
    <h3>
      Application Submission Number: {{confirmationAppId}}
    </h3>
    <div class="inner-sec">
      <div class="plan-sec d-flex-between">
        <div class="left-sec">

          <div class="entity-grid item">
            <div class="label">Name </div>
            <span> : </span>
            <div class="value">{{submittedApplicantName}} </div>
          </div>

          <div class="entity-grid item">
            <div class="label">Plan </div>
            <span> : </span>
            <div class="value">{{planName}}</div>
          </div>

          @if (ratingEntity) {
            <div class="entity-grid item">
              <div class="label">Entity </div>
              <span> : </span>
              <div class="value">{{ratingEntity}}</div>
            </div>
          }

        </div>
        <div class="right-sec">
          <div class="entity-grid item">
            <div class="label">Submitted Date </div>
            <span> : </span>
            <div class="value">{{currentDate|date:'MM/dd/yyyy'}}</div>
          </div>
          <div class="entity-grid item">
            <div class="label">Effective Date </div>
            <span> : </span>
            <div class="value">{{effectiveDate}}</div>
          </div>
        </div>
      </div>
      <div class="email-sec d-flex-between">

        <div class="lower-div">
          <slot name="post-submission-container"><a href="javacript:void(0)">EMAIL SUBMISSION NUMBER</a></slot>
        </div>

        <div class="print">
          @switch (printButtonExperienceType) {
            @case ('special-enrollment') {
              <app-populated-special-enrollment-form-print label="DOWNLOAD APPLICATION"></app-populated-special-enrollment-form-print>
            }
            @case ('enhanced-pdf-print') {
              <app-submitted-application-pdf-print
                label="DOWNLOAD APPLICATION"
                [printType]="PRINT_TYPES.APPLICATION_FORM"
              ></app-submitted-application-pdf-print>
            }
            @default {
              <app-print-button label="DOWNLOAD APPLICATION"></app-print-button>
            }
          }
          @if (showSecondPrint) {
            @switch (altOnePrintExperience) {
              @case ("domestic-partner-attestation-pdf") {
                <app-submitted-application-pdf-print 
                  label="DOWNLOAD DOMESTIC PARTNER ATTESTATION PDF"
                  [printType]="PRINT_TYPES.DOMESTIC_PARTNER_ATTESTATION"
                ></app-submitted-application-pdf-print>
              }
              @default {
                
              }
            }
          }
        </div>


      </div>
      <!-- <app-individual-payment></app-individual-payment> -->
      @if (showPayPremium) {
        <div>
          <p><strong>PAY YOUR FIRST PREMIUM: {{planPremium | currency}}</strong></p>
          <slot name="pay-premium-container"></slot>
          <p>Click the button below to to pay your premium. <strong>Note: </strong>You will be redirected to payment site.</p>
          <div>
            <!-- // TODO: Move this to EBILL SSO component.. -->
            <button type="submit" mat-raised-button color="primary" class="primary-btn" (click)="ssoEbill()">PAY
            PREMIUM</button>
          </div>
          <br/>
          <p><strong>PLEASE NOTE:<br>This Agreement renews on an annual basis. If the first payment is not made with this application, the first premium payment is due by the due date printed on your first invoice. You are solely responsible for accurate and timely payment of premiums. Failure to pay before this due date will result in your application being cancelled. You can also pay your premium monthly in advance@if(!suppressBrandDescription) { to {{brandDescription}}}. If it's convenient, you may pay more than your monthly amount. We will apply excess amounts on a monthly basis. These amounts will be subject to premium increases on the date the increase is effective.</strong>
        </p>
        <strong>
          <p>We must receive and process your full premium payment before we can pay claims for any eligible services you receive. If your on-going monthly premium payments are not received in the full amount within the plan grace period, your plan will be terminated. The termination date will be the last month in which we received your required payment. Claims for eligible services will not be processed unless your current premium has been paid in full.</p>
        </strong>
      </div>
    }
  </div>
</div>
</div>